import React from "react";
import ReactDOM from "react-dom/client";

import "./CSS/style.css";

import { books } from "./books";
import Books from "./Book";

// function Greeting() {
//   return <h2>My First Component....</h2>;
// }
const root = ReactDOM.createRoot(document.getElementById("root"));

// function Greeting() {
//   return (
//     <div>
//       <h1>Greeting</h1>
//     </div>
//   );
// }

// Using JFX

// function Greeting() {
//   return React.createElement(
//     "div",
//     {},
//     React.createElement("h2", {}, "Hello world")
//   );
// }

// export default Greeting;

// Nexted components

// function Greeting() {
//   return (
//     <div>
//       <Person />
//       <Message />
//     </div>
//   );
// }

// const Person = () => {
//   return <h1>Brijesh</h1>;
// };

// const Message = () => {
//   return <p>Hello People.</p>;
// };

// export default Greeting;
// root.render(<Greeting />);

// //////////////////////////
// Project 1

const BookList = () => {
  return (
    <>
      <h1>Amazon Best Sellers</h1>
      <section className="booklist">
        {books.map((book, index) => {
          return <Books {...book} key={book.id} index={index} />;
        })}
      </section>
    </>
  );
};

export default BookList;
root.render(<BookList />);
